export const ConfigClientes = {
   barraBusqueda: {
      criterios: ["Razon Social", "Rut Cliente", "Giro"],
      criteriosKeys: ["razonSocial", "rutReceptorDv", "giro"],
      criterioPrincipal: "Razon Social",
   },
   table: {
      title: "Facturación Emitida",
      add: "Carga Documento",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
